import { render } from "./ContentBlockWithImagesAndCaptionsPreview.vue?vue&type=template&id=7a9ad954&scoped=true"
import script from "./ContentBlockWithImagesAndCaptionsPreview.vue?vue&type=script&lang=js"
export * from "./ContentBlockWithImagesAndCaptionsPreview.vue?vue&type=script&lang=js"

import "./ContentBlockWithImagesAndCaptionsPreview.vue?vue&type=style&index=0&id=7a9ad954&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9ad954"]])

export default __exports__